var React = require('react');

function EmailInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.8 22.0999H5.19998C4.51041 22.0999 3.84909 21.826 3.3615 21.3384C2.8739 20.8508 2.59998 20.1895 2.59998 19.4999V6.4999C2.59998 5.81034 2.8739 5.14902 3.3615 4.66142C3.84909 4.17383 4.51041 3.8999 5.19998 3.8999H20.8C21.4895 3.8999 22.1509 4.17383 22.6385 4.66142C23.126 5.14902 23.4 5.81034 23.4 6.4999V19.4999C23.4 20.1895 23.126 20.8508 22.6385 21.3384C22.1509 21.826 21.4895 22.0999 20.8 22.0999ZM20.8 19.4999V9.9046L13 15.4192L5.19998 9.9046V19.4999H20.8ZM5.19998 6.4999V7.4164L13 11.8741L20.8 7.4164V6.4999H5.19998Z","fill":"white"}));
}

EmailInline.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = EmailInline;

EmailInline.default = EmailInline;
